export enum QueryTypeEnum {
    IdentityNumber = 1,
    RegistryNumber = 2,
    SubscriberNumber = 3,
    TaxNumber = 4
}
  